import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["format", "parse", "guard"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback, useEffect, useState } from 'react';
import { useField } from 'formik';
import { isNil } from 'ramda';
import { EFormEvent, useFormEventBus } from '../formEventBus';
export function applyFormatter(value, formatter) {
  return formatter && !isNil(value) ? formatter(value) : value || '';
}
export function applyGuard(value, guard) {
  return guard ? guard(value) : value;
}
export function applyParser(value, parser) {
  return parser ? parser(value) : value;
}

/**
 * Обертка над useField из Formik для добавления поддержки гварда, парсера и форматтера
 * Value - тип для фактического значения (например для числового поля это будет number)
 * @param {TBaseFormFieldProps} props - параметры поля
 */
export function useFormField(props) {
  var format = props.format,
    parse = props.parse,
    guard = props.guard,
    rest = _objectWithoutProperties(props, _excluded);

  // Приведение типов, т.к. после обновления до React 18 появляется баг с несовместимостью children.
  var _useField = useField(rest),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var formEventBus = useFormEventBus();
  var _useState = useState(applyFormatter(meta.value, format)),
    _useState2 = _slicedToArray(_useState, 2),
    displayValue = _useState2[0],
    setDisplayValue = _useState2[1];

  /**
   * После сброса формы нужно синхронизировать
   * реальное (field.value) и отображаемое (displayValue) значения поля
   */
  useEffect(function () {
    var unsubscribe = formEventBus.on(EFormEvent.AfterReset, function () {
      setDisplayValue(applyFormatter(field.value, format));
    });
    return unsubscribe;
  }, [formEventBus, field.value, format]);
  var onChange = useCallback(function (e) {
    var filtered = applyGuard(e.target.value, guard);
    var parsed = applyParser(filtered, parse);
    helpers.setValue(parsed, false);

    /**
     *  Если есть форматтер, то применяем его относительно спарсенного значения
     *  Иначе просто применяем значение введенное в инпут, пропущенное через гвард
     */
    setDisplayValue(format ? applyFormatter(parsed, format) : filtered);

    /** При вводе в поле ошибка будет сбрасываться, если есть */
    if (meta.error) {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      helpers.setError(undefined);
    }
  }, [guard, parse, format, helpers, meta.error]);
  var onBlur = useCallback(function (e) {
    setDisplayValue(applyFormatter(field.value, format));
    field.onBlur(e);
  }, [field, format]);
  return {
    field: _objectSpread(_objectSpread({}, field), {}, {
      onChange: onChange,
      onBlur: onBlur
    }),
    meta: meta,
    helpers: helpers,
    displayValue: displayValue
  };
}